/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect, useState } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import OnboardingStart from '../../components/OnboardingStart';
import { getKnowledgeBase } from '../../knowledge-base/actions/KnowledgeBaseActions';
import { selectKnowledgeBase, selectKnowledgeBasesFetched, selectKnowledgeBasesNotFetched } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { KB_ONBOARDING_PATH } from '../constants/RouteConstants';
import KBv3EnrollmentModal from '../../v3-beta/components/KBv3EnrollmentModal';
import { useHasGate } from '../../auth/hooks/authHooks';
import { GATES } from '../../utils/gatesUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KBv3BetaTerms = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const {
    search
  } = useLocation();
  const needsToFetchKnowledgeBase = useAppSelector(selectKnowledgeBasesNotFetched);
  const hasFetchedKnowledgeBases = useAppSelector(selectKnowledgeBasesFetched);
  const defaultKnowledgeBaseId = useAppSelector(state => {
    const currentKnowledgeBase = selectKnowledgeBase(state);
    return currentKnowledgeBase ? currentKnowledgeBase.id : null;
  });
  const {
    hasGate: hasKBv3Gate
  } = useHasGate(GATES.KNOWLEDGE_BASE_V3_1);
  const [showEnrollmentModal] = useState(hasKBv3Gate);
  useEffect(() => {
    if (needsToFetchKnowledgeBase) {
      dispatch(getKnowledgeBase());
    }
  }, [dispatch, needsToFetchKnowledgeBase]);
  if (!hasFetchedKnowledgeBases) {
    return null;
  }
  if (defaultKnowledgeBaseId === null) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [showEnrollmentModal && /*#__PURE__*/_jsx(KBv3EnrollmentModal, {}), /*#__PURE__*/_jsx(OnboardingStart, {
        isSetupDisabled: false,
        onClick: () => history.push(`${KB_ONBOARDING_PATH}?cancel=back`)
      })]
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    from: "/",
    to: `/${defaultKnowledgeBaseId}/${search}`
  });
};
export default KBv3BetaTerms;